import dropUploadKeysOnSuccess from 'root/src/client/logic/tableItem/actions/dropUploadKeysOnSuccess'
import updateStepsCompleted from 'root/src/client/util/updateStepsCompleted'

export default body => async (dispatch, getState) => {
	dispatch(dropUploadKeysOnSuccess(body))
	updateStepsCompleted('hasKeysAndProducts', dispatch, getState)
}
